import { render, staticRenderFns } from "./BaseExternalLink.vue?vue&type=template&id=fcac1e34&scoped=true&"
import script from "./BaseExternalLink.vue?vue&type=script&lang=js&"
export * from "./BaseExternalLink.vue?vue&type=script&lang=js&"
import style0 from "./BaseExternalLink.styl?vue&type=style&index=0&id=fcac1e34&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcac1e34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
